import { useEffect } from 'react';
import axios from 'axios';
import { useAuthHeader } from 'react-auth-kit';
import { setServerVerifiedLevel, markVerificationFailed } from '../utils/roleUtils';

/**
 * Verifikasi role user dari server (auth/me) pada mount.
 * Menggunakan token dari react-auth-kit (cookie) — lebih terpercaya dari localStorage.
 * Hasilnya di-set ke serverVerifiedLevel di roleUtils sehingga server menjadi source of truth.
 * Jika verifikasi gagal, roleUtils menerapkan deny-by-default (read-only).
 */
export const useVerifyRole = (): void => {
  const authHeader = useAuthHeader();

  useEffect(() => {
    const header = authHeader();
    if (!header) {
      markVerificationFailed();
      return;
    }

    axios
      .get(`${process.env.REACT_APP_BE_PROD_BASE_URL}auth/me`, {
        headers: { Authorization: header },
      })
      .then((res) => {
        const level: string | undefined = res.data?.data?.level;
        if (level) setServerVerifiedLevel(level);
        else markVerificationFailed();
      })
      .catch(() => markVerificationFailed());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
